import { Flex } from 'antd'
import { useMemo } from 'react'
import { Table } from 'src/app/shared/components'
import TableNoRowOverlay from 'src/app/shared/components/common/new-table/components/TableNoRowOverlay'
import InfiniteTable from 'src/app/shared/components/common/table/components/InfiniteTable'

interface Props {
  fileContainsHeaderRow: boolean
  fileData: Array<Array<string>>
  columnDefs: any
  isTxtFile?: boolean
  loading?: boolean
}

function FilePreview(props: Readonly<Props>) {
  const { fileContainsHeaderRow, fileData, columnDefs, isTxtFile, loading } = props

  const rowData = useMemo(() => {
    if (fileData) {
      const data = fileData?.slice(fileContainsHeaderRow ? 1 : 0)
      return data?.map((row) => {
        let obj: any = {}
        columnDefs?.forEach((col: any, index: any) => {
          obj[col.field] = row[index]
        })
        return obj
      })
    }
  }, [fileContainsHeaderRow, fileData, columnDefs])

  const customeColumnDefs = columnDefs?.map((col: any) => ({
    ...col,
    cellDataType: false,
  }))

  return (
    <div className='preview-table'>
      {isTxtFile ? (
        <Flex style={{ paddingBottom: '32px' }}>
          <InfiniteTable
            columnDefs={customeColumnDefs}
            rowData={rowData}
            fileContainsHeaderRow={fileContainsHeaderRow}
          />
        </Flex>
      ) : (
        <Table
          loading={loading}
          columnDefs={customeColumnDefs}
          rowData={rowData}
          displayActionColumn={false}
          handleDownload={() => Promise.resolve({})}
          handleChooseColumn={() => Promise.resolve({})}
          handleSearch={() => Promise.resolve({})}
          disableTableControl={true}
          autoSort={false}
          getHeaderName={null}
          noRowsOverlayComponent={TableNoRowOverlay}
        />
      )}
    </div>
  )
}

export default FilePreview
